<!-- Display a message that the RadioDecoder is silenced. -->

<template>
  <v-list-tile>
    <v-list-tile-avatar>
      <v-icon
        color="msr"
        medium
      >
        volume_off
      </v-icon>
    </v-list-tile-avatar>
    <v-list-tile-sub-title>
      <v-layout
        align-center
        wrap
      >
        {{ $t('radioDecoderIsSilencedHint') }}
      </v-layout>
    </v-list-tile-sub-title>
  </v-list-tile>
</template>

<script>
export default {
  name: 'RadioDecoderSilencedWarning',
};
</script>



// WEBPACK FOOTER //
// src/components/DecoderDetail/RadioDecoderSilencedWarning.vue